module.exports = __webpack_public_path__ + "static/media/logo-playstation.80ff1244.svg";